/**
 * Agent sign-in uses the auth user only. A wrong password stays on this
 * form. Homeowners sign in on the homeowner form, which calls homeowner-login
 * by itself.
 */

const WRONG_PASSWORD_MESSAGE = 'That email or password is incorrect.';

function errorMessage(error) {
  return String((error && (error.message || error.error_description || error.msg)) || '').toLowerCase();
}

function agentCredentialFailure(error) {
  if (!error) return false;
  const message = errorMessage(error);
  if (/not confirmed/.test(message)) return false;
  const status = Number(error.status || error.statusCode || 0);
  if (status === 400 || status === 401) return true;
  return /invalid login|invalid credentials|invalid email or password|user not found/.test(message);
}

function signInFailureMessage(error) {
  const message = String((error && (error.message || error.error_description || error.msg)) || '');
  if (/not confirmed/i.test(message)) return 'Check your email, then sign in.';
  return WRONG_PASSWORD_MESSAGE;
}

async function signInWithEmail({ email, password, signInAgent }) {
  try {
    const result = await signInAgent(email, password);
    if (result && result.error) return { kind: 'error', error: result.error };
    return { kind: 'agent', result };
  } catch (error) {
    return { kind: 'error', error };
  }
}

module.exports = {
  WRONG_PASSWORD_MESSAGE,
  agentCredentialFailure,
  signInFailureMessage,
  signInWithEmail,
};
